import React, { useState, useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { classSessionAction } from "redux/actions";
import { TabModal } from "components";
import CategoryDetails from "./CategoryDetails";
import LocationDetails from "./LocationDetails";
import EditSessionDetails from "./EditSessionDetails";

export default function EditClassSessionPopup({ closeModal, data }) {
  // redux
  const dispatch = useDispatch();

  // states
  const [tabIndex, setTabIndex] = useState(0);
  const [details, setDetails] = useState();

  // useEffects
  useEffect(() => {
    if (!data) return;

    const {
      id,
      class_date,
      class_time,
      sp_id,
      join_url,
      status
    } = data;

    setDetails({
      class_session_id: id,
      class_date: class_date,
      class_time: class_time,
      sp_id: sp_id,
      join_url: join_url,
      status: status
    });
  }, [data]);

  useEffect(() => {
    console.log({ details });
  }, [details]);

  // Handle change in Form
  const handleChange = e => {
    setDetails(prev => ({
      ...prev,
      [e.target.name]: isNaN(e.target.value)
        ? e.target.value
        : parseFloat(e.target.value)
    }));
  };

  // On Submit Data to Server
  const submit = () => {
    console.log('===========>>>>>>>'+JSON.stringify(details));
    // if (!details?.subCategoryID || !details?.cityID || !details?.ruleID) {
    //   alert("City, Sub Category & Rule ID is mandatory.");
    //   return;
    // }

    setTabIndex(0);
    closeModal();
    dispatch(classSessionAction.update(details));
  };

  // Popup tabs routes
  const modalTabs = useMemo(
    () => [
      {
        name: "Session Details",
        component: (
          <EditSessionDetails
            key={3}
            onClick={submit}
            details={details}
            package_id={data.package_id}
            setDetails={handleChange}
          />
        )
      }
    ],
    [details]
  );

  return (
    <TabModal
      tabTitle={"Edit Class Sessions"}
      tabs={modalTabs}
      tabIndex={tabIndex}
      setTabIndex={index => setTabIndex(index)}
      closeModal={() => {
        setTabIndex(0);
        closeModal();
      }}
    />
  );
}
